// Event type to tag color class mapping
export const eventTagColors = {
  program_start: 'event-tag-program-start',
  qme1: 'event-tag-qme',
  qme2: 'event-tag-qme',
  qme3: 'event-tag-qme',
  physical_assessment: 'event-tag-medical',
  consultation: 'event-tag-default',
  renewal: 'event-tag-renewal',
  renew: 'event-tag-renewal',
  initial_contact: 'event-tag-initial-contact'
}

// Event type to display name mapping
export const eventDisplayNames = {
  program_start: 'Program Start',
  qme1: 'QME1',
  qme2: 'QME2',
  qme3: 'QME3',
  physical_assessment: 'Physical Assessment',
  consultation: 'Initial Consultation',
  renewal: 'Renewal',
  renew: 'Renew',
  initial_contact: 'Initial Contact'
}

// Get the tag color class for an event type
export const getEventTagClass = (eventType) => {
  return eventTagColors[eventType] || 'event-tag-default'
}

// Format event type for display
export const formatEventType = (eventType) => {
  if (!eventType) return ''
  // First check if we have a display name for this exact event type
  if (eventDisplayNames[eventType]) {
    return eventDisplayNames[eventType]
  }
  // Fallback: convert snake_case to Title Case
  return eventType
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

// Create filter options from eventDisplayNames - always show all possible options
export const eventFilterOptions = Object.entries(eventDisplayNames).map(([value, label]) => ({
  label,
  value: value.toLowerCase()
}))
